import { Component, Input, OnInit, OnChanges, OnDestroy, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Product } from '@app/core/business/product/product';
import { ProductService } from '@app/core/business/product/product.service';
import { ContextService } from '@app/core/service/context.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { interval, Subscription } from 'rxjs';
import { ProductAvailability } from '@app/core/business/product/product-availability';

@UntilDestroy()
@Component({
  selector: 'app-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['./availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvailabilityComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  public product: Product;
  @Input()
  public productCode: string;
  @Input()
  public outer: string;
  @Input()
  public unpackedQuantity: string;
  @Input()
  public theme: string;
  @Input()
  public showStockIndicator: boolean = true;

  /**
   * CLA le 10/10/2019 - A/B - passage d'un texte pour décrire une indisponibilité produit
   */
  public availability: ProductAvailability = null;
  public updating = false;
  private availabilitySubscription: Subscription;
  @Output() availabilityLoaded = new EventEmitter<void>();

  constructor(
    private contextService: ContextService,
    private productService: ProductService,
    private cdr: ChangeDetectorRef
  ) {
    this.theme = 'dark';
  }

  ngOnInit() {

    if (
      this.productCode &&
      this.product.availabilityRefreshRate *
      1000 >
      0
    ) {

      interval(
        this.product.availabilityRefreshRate * 1000
      )
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          // Each interval of time from the company setting, update availability
          this.updateAvailability();
        });
    }
  }

  ngOnChanges() {
    if (this.availabilitySubscription) {
      this.availabilitySubscription.unsubscribe();
    }

    if (this.product && (this.product.availabilityRefreshRate === 0)) {
      this.availability = this.product.availability;
      this.availabilityLoaded.emit();
    } else {
      this.updateAvailability();
    }
  }

  private async updateAvailability() {
    if (!this.productCode) return;

    this.updating = true;
    this.cdr.markForCheck();
    const isDateCourte = this.product.isDateCourte;

    this.availabilitySubscription = this.productService
      .getProductAvailability(
        this.contextService.context.companyCode,
        this.productCode,
        this.contextService.context.customerCode,
        isDateCourte,
        this.contextService.context.orderCode
      )
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (availability: ProductAvailability) => {
          this.availability = availability;
          this.updating = false;
          this.cdr.markForCheck();
          this.availabilityLoaded.emit();

        },
        error: () => {
          this.updating = false;
          this.cdr.markForCheck();
        }
      });


  }

  ngOnDestroy() { }
}
